<template>
  <div>
    <v-carousel cycle  interval="3000" progress height="350" hide-delimiters continuous>
      <v-carousel-item
        v-for="(item,i) in sliders"
        :key="i"
          :src="item.image"
      >
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Banner',
  data: () => ({
    items: [
      {
        src: 'https://res.cloudinary.com/dd5jfnv3x/image/upload/v1555617300/slider-irs-market.png'
      }
    ]
  }),
  computed: {
    ...mapState('PublicStore', ['sliders'])
  }
}
</script>

<style scoped>

</style>
